import { Button, DataSource, HorizontalSpacer, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiReqdFldGrpExpanded extends Layout {
    buttonAddRequiredField: Button;
    horizontalspacer1: HorizontalSpacer;
    labelRuleHeader: Label;
    sourceEdiRequiredField: DataSource;
    tableEdiRequiredField: Table;
}
